import http from "../utils/http";
// get请求
export default {
  companyProfileselect(params) {
    return http.get(`/officialWeb_api/api/companyProfile/select`, params);
  },
  selectNews(params) {
    return http.get(`/officialWeb_api/api/companyNews/selectNews`, params);
  },

  selectTimeline(params) {
    return http.get(
      `/officialWeb_api/api/companyTimeline/selectTimeline`,
      params
    );
  },
  addCoopera(params) {
    return http.post(
      `/officialWeb_api/api/companyCooperate/addCoopera`,  
      params
    );
  },
  selectAll(params) {
    return http.get(`/officialWeb_api/api/companyPositions/selectAll`, params);
  },
  companyCoreTechnologySelectAll(params) {
    return http.get(
      `/officialWeb_api/api/companyCoreTechnology/selectAll`,
      params
    );
  },
  selectByProject(params) {
    return http.get(
      `/officialWeb_api/api/companyProject/selectByProject`,
      params
    );
  },
  selectLink(params) {
    return http.get(
      `/officialWeb_api/api/companyEmbedLinks/selectLink`,
      params
    );
  },
  //查询首页菜单
  selectMenu(params) {
    return http.get(`/officialWeb_api/api/navigationBar/recursion`, params);
  },
  //查询首页Banner
  selectBanner(params) {
    return http.get(`/officialWeb_api/api/bannerManage/bannerDisplay`, params);
  },
  //首页查询slogan
  selectSlogan(params) {
    return http.get(`/officialWeb_api/api/companyProfile/select`, params);
  },
  //查询首页合作伙伴
  selectPartner(params) {
    return http.get(`/officialWeb_api/api/partners/partnersDisplay`, params);
  },
  //查询首页模块顺序
  selectModuleOrder(params) {
    return http.get(`/officialWeb_api/api/homepageModules/getHomepage`, params);
  },
  //查询卡片
  selectCard(params) {
    return http.get(`/officialWeb_api/api/cardManagement/getCardByType`, params);
  },
  //查询专题模块
  selectSpecialModule(params) {
    return http.get(`/officialWeb_api/api/special/getSpecial`, params);
  },
};
